import type {
	DocumentGenerationVersion,
	DocumentHistoryVersion,
	DocumentUniqueId,
} from "@src/components/collaboration/document-id";
import {
	BaseDocumentId,
	customNanoId,
} from "@src/components/collaboration/document-id/base-document-id";

export class ThreadsDocumentId extends BaseDocumentId {
	constructor(
		id?: DocumentUniqueId,
		generationVersion?: DocumentGenerationVersion,
		historyVersion?: DocumentHistoryVersion,
	) {
		super("threads", id ?? customNanoId(), generationVersion, historyVersion);
	}

	atGenerationVersion(generationVersion: DocumentGenerationVersion) {
		return new ThreadsDocumentId(
			this.id,
			generationVersion,
			this.historyVersion,
		);
	}

	atHistoryVersion(historyVersion: DocumentHistoryVersion) {
		return new ThreadsDocumentId(
			this.id,
			this.generationVersion,
			historyVersion,
		);
	}
}
